import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=7410a6f5&scoped=true&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7410a6f5",
  null
  
)

component.options.__file = "Contact.vue"
export default component.exports